import FixedMessage from './fixedMessage'
import Loader from './loader'
import AnimatedProgressBar from './animatedProgressBar'
import ProgressTimeline from './progressTimeline'
import Button, { ButtonColors } from './button'
import CountdownButton from './countdownButton'
import Icon from './icon'
import InfoPill from './infoPill'
import Chip, { ChipColor } from './chip'
import JsonBeforeAfter from './jsonBeforeAfter'
import JsonEditor from './jsonEditor'
import JsonViewer from './jsonViewer'
import { SIZES } from './text'
import LabelValue from './labelValue'
import LabeledProgressBar from './labeledProgressBar'
import Notification from './notification'
import Ribbon from './ribbon'
import MobileRibbon from './mobileRibbon'
import TagDropdown from './tagDropdown'
import Alert from './alert'
import UtilityCard from './utilityCard'
export { AlertRole, type AlertRoleType } from './alert'
import Badge from './badge'
import Money from './money'
import MapPin from './mapPin'
import Pulser from './pulser'
import EnhancedDropdown from './enhancedDropdown'
import Filter from './filter'
import FilterGroupLayout from './filter/filterGroupLayout'
import FilterToolbar from './filterToolbar'
import MobileFilter from './filter/mobileFilter'
import HorizontalExpander from './horizontalExpander'
import VerticalExpander from './verticalExpander'
import Animate from './animate'
import SearchFilter from './searchFilter'
import StatusMessage from './statusMessage'
import InitialsAvatar from './initialsAvatar'
import CardContainer from './cardContainer'
import CardIconTitle from './cardIconTitle'
import EmptyState from './emptyState'
import Term from './term'
import TermsCard from './termsCard'
import PeriodIndicator from './periodIndicator'
import CopyButton from './copyButton'
import CopyableField from './copyableField'
import CopyableText from './copyableText'
import MarkdownRenderer from './markdownRenderer'
import MarkdownWithComponents from './markdownWithComponents'
import StarRating from './starRating'
import Statistic from './statistic'
import SectionCard from './sectionCard'

// This is useful in many contexts across our apps, usually when a component slot if dynamic and we want to render
// _something_ there and the calling code isn't configured to use a null value directly since it expects an element.
//
// See `overridableComponents` in the application shell for a good example where this pattern is used.
const NullComponent: React.FC = () => null
// This is useful when creating dynamic component where the wrapper can be empty and we don't want guard conditions
// since the component is assigned to a dynamic variable. More of a style thing.
const PassthroughComponent: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => children

export { default as Text } from './text'
export { default as InlineInput } from './inlineInput'
export type { InlineInputProps } from './inlineInput'
export type { IconStyle, IconSize, IconProps } from './icon'
export type { MarkdownRendererProps } from './markdownRenderer'
export type { StarRatingProps } from './starRating'
export type { MarkdownWithComponentsProps } from './markdownWithComponents'
export type {
  MarkdownComponentAction,
  MarkdownComponentMap,
  ConfirmAction,
} from './markdownWithComponents/types'
export { isConfirmAction } from './markdownWithComponents/types'
export { MarkdownConfirm } from './markdownWithComponents/components'
export type {
  JsonEditorSchema,
  JsonFieldSchema,
  SchemaToType,
  StringField,
  NumberField,
  BooleanField,
  EnumField,
  ObjectField,
  ArrayField,
} from './jsonEditor/schema'
export {
  AnimatedProgressBar,
  FixedMessage,
  Loader,
  Button,
  ButtonColors,
  CountdownButton,
  Icon,
  InfoPill,
  Chip,
  ChipColor,
  JsonBeforeAfter,
  JsonEditor,
  JsonViewer,
  SIZES,
  Notification,
  Ribbon,
  MobileRibbon,
  TagDropdown,
  Alert,
  Badge,
  NullComponent,
  PassthroughComponent,
  Money,
  MapPin,
  Pulser,
  EnhancedDropdown,
  Filter,
  FilterGroupLayout,
  FilterToolbar,
  MobileFilter,
  VerticalExpander,
  HorizontalExpander,
  Animate,
  SearchFilter,
  StatusMessage,
  LabelValue,
  LabeledProgressBar,
  InitialsAvatar,
  CardContainer,
  CardIconTitle,
  UtilityCard,
  EmptyState,
  Term,
  TermsCard,
  PeriodIndicator,
  ProgressTimeline,
  CopyButton,
  CopyableField,
  CopyableText,
  MarkdownRenderer,
  MarkdownWithComponents,
  StarRating,
  Statistic,
  SectionCard,
}

export type { UtilityCardProps, UtilityCardCta } from './utilityCard'
